export const CHURCH_ADMIN_ROLE = ['አባል'];
export const DISTRICT_ADMIN_ROLE = ['የአጥቢያ አስተዳዳሪ', 'አባል'];
export const ASSISTANT_ADMIN_ROLE = ['የአውራጃ አስተዳዳሪ', 'የሃገረስብከት አጥቢያ አስተዳዳሪ', 'የአጥቢያ አስተዳዳሪ', 'አባል'];
export const DIOCESE_ADMIN_ROLE = ['ረዳት አስተዳዳሪ', 'የአውራጃ አስተዳዳሪ', 'የሃገረስብከት አጥቢያ አስተዳዳሪ', 'የአጥቢያ አስተዳዳሪ', 'አባል'];